import { RemoteSourceAutoComplete } from 'components/RemoteSourceAutoComplete';
import apiEndpoints from 'constants/endpoints';
import React from 'react';

export const EventTypeSelect = ({ onChange, eventTypeId, disabled = false, placeholder, params = {} }) => {
  return (
    <RemoteSourceAutoComplete
      apiPath={apiEndpoints.eventTypes}
      queryParams={params}
      searchKey="searchStr"
      selectedId={eventTypeId}
      disabled={disabled}
      getOptionLabel={(option => `${option.id} - ${option.name}`)}
      onChange={onChange}
      placeholder={placeholder || "Event Type"}
    />
  )
};
